import React from "react";
import ReactDOM from "react-dom";
import {Simulation} from './screens/Simulation.'

const rootElement = document.getElementById("root");
ReactDOM.render(<Simulation />, rootElement);


